import type { DetectedLink } from '../../integrations';

function formatNotionPageId(hex: string): string {
  if (hex.length !== 32) return hex;
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
}

export function detectNotionLink(url: string): DetectedLink | null {
  const standardMatch = url.match(
    /https?:\/\/(?:www\.)?notion\.(?:so|site)\/(?:[^/#?]+\/)?(?:[^/#?-]+-)?([a-f0-9]{32})/i
  );
  if (standardMatch) {
    return {
      url,
      integrationType: 'notion',
      resourceType: 'page',
      resourceId: formatNotionPageId(standardMatch[1]),
    };
  }
  const siteMatch = url.match(
    /https?:\/\/([^.]+)\.notion\.(?:so|site)\/(?:[^/#?-]+-)?([a-f0-9]{32})/i
  );
  if (siteMatch) {
    return {
      url,
      integrationType: 'notion',
      resourceType: 'page',
      resourceId: formatNotionPageId(siteMatch[2]),
      notionWorkspaceId: siteMatch[1],
    };
  }
  return null;
}
